export function getBrowserVersion() {
  const { userAgent } = navigator;

  let browser;
  let version;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg') && !userAgent.includes('OPR')) {
    browser = 'Google Chrome';

    // eslint-disable-next-line prefer-destructuring
    version = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/)?.[1];
  } else if (userAgent.includes('Firefox')) {
    browser = 'Mozilla Firefox';

    // eslint-disable-next-line prefer-destructuring
    version = userAgent.match(/Firefox\/(\d+\.\d+)/)?.[1];
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    browser = 'Apple Safari';

    // eslint-disable-next-line prefer-destructuring
    version = userAgent.match(/Version\/(\d+\.\d+)/)?.[1];
  } else if (userAgent.includes('Edg')) {
    browser = 'Microsoft Edge';

    // eslint-disable-next-line prefer-destructuring
    version = userAgent.match(/Edg\/(\d+\.\d+)/)?.[1];
  } else if (userAgent.includes('OPR') || userAgent.includes('Opera')) {
    browser = 'Opera';

    // eslint-disable-next-line prefer-destructuring
    version = userAgent.match(/OPR\/(\d+\.\d+)/)?.[1];
  } else {
    browser = "Noma'lum brauzer";
    version = "Noma'lum";
  }

  return `${browser} - ${version}`;
}
